import { AdjustCoinStatusSelectTab } from './AdjustCoinStatusSelectTab'
import { withAdjustCoinStatusSelectTab } from './withAdjustCoinStatusSelectTab'

const ConnectedAdjustCoinStatusSelectTab = withAdjustCoinStatusSelectTab(
  AdjustCoinStatusSelectTab
)

export { ConnectedAdjustCoinStatusSelectTab as AdjustCoinStatusSelectTab }
